import { SummaryController } from '../controllers/summaryController';
import templateUrl from './orderSummary.html';

export function CartDirective() {
    return {
        templateUrl,
        restrict: 'E',
        controller: SummaryController,
        link: function() {},
        replace: true
    };
}
